<template>
    <el-dialog class="el-dialogs" append-to-body :title="title" width="650px" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="130px">
            <el-form-item label="节点名称：" prop="nodeId">
                <div class="flex_l_c">
                    <el-select v-model="searchForm.nodeId" class="inputWidth" placeholder="请选择节点名称"
                               @change="getNodeName()"
                               clearable>
                        <el-option
                                v-for="item in nodeNameList"
                                :key="item.id"
                                :disabled="item.knowledgeId ? true : false"
                                :label="item.knowledgeName + item.userName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <div style="margin-left: 15px;">
                        <el-checkbox-group v-model="checkList" @change="setNodeNameList()">
                            <el-checkbox label="1">我的节点</el-checkbox>
                            <el-checkbox label="2">节点管理</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="来源：" prop="knowledgeSource">
                <div class="inputWidth">{{ searchForm.knowledgeSource }}</div>
            </el-form-item>
            <el-form-item label="父节点：" prop="parentId">
                <treeSelect ref="menuParentTree"
                            class="inputWidth"
                            :props="{
                                           children: 'children',
                                           label: 'knowledgeName',
                                           value:'id'
                                          }"
                            :data="fatherNodeList"
                            :value="searchForm.parentId"
                            :clearable="true"
                            :accordion="true"
                            @getValue="selectCascader"
                ></treeSelect>
            </el-form-item>
            <el-form-item label="关联元数据：" prop="metadata">
                <el-select v-model="searchForm.metadata" class="inputWidth" placeholder="请选择关联元数据"
                           @change="getNodeName()"
                           clearable>
                    <el-option
                            v-for="item in associationList"
                            :key="item.basicCode"
                            :label="item.basicName"
                            :value="item.basicCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态：" prop="graphNodeState">
                <el-switch
                        v-model="searchForm.graphNodeState"
                        active-value="1"
                        inactive-value="0">
                </el-switch>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input v-model.trim="searchForm.remark" maxlength="500"
                          type="textarea" :rows="5" resize="none" class="inputWidth"
                          placeholder="请输入备注(限500字)"
                          clearable></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
            <el-button size="small" @click="visible = false">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import treeSelect from "@/components/treeSelect/treeSelect.vue";

export default {
    name: "addMinNode",
    components: {treeSelect},
    data() {
        return {
            title: '新增节点',
            visible: false,
            searchForm: {
                id: '',
                nodeId: '',
                knowledgeSource: '',
                parentId: '',
                metadata: '',
                graphNodeState: '0',
                knowledgeId: "",
                remark: '',
            },
            rules: {
                nodeId: [
                    {required: true, message: '请选择节点名称', trigger: 'blur'}
                ],
            },
            nodeNameList: [],
            checkList: ['1'],
            fatherNodeList: [],
            associationList: [],
            listSetlectData: {},
            topRow: {},
        }
    },

    methods: {
        //type add新增 edit编辑
        init(type, row, setlectData, parentId) {
            this.visible = true
            this.listSetlectData = setlectData
            this.topRow = row
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
            this.getMetadata(parentId)
            this.searchForm.id = ''
            if (type == 'add') {
                this.checkList = ['1']
                this.title = '新增节点'
            }
            if (type == 'edit') {
                this.title = '编辑节点'
                this.checkList = ['1', '2']
                this.getDetail()
            }
            this.setNodeNameList()
        },

        //获取详情
        getDetail() {
            this.$axios(this.api.academic.knowledgegraphnoeGetById + this.topRow.id, {}, 'get').then(data => {
                if (data && data.status) {
                    Object.keys(this.searchForm).forEach(key => {
                        this.searchForm[key] = data.data[key]
                    })
                }
            })
        },

        selectCascader(val, label, node) {
            this.searchForm.parentId = val
        },

        getNodeName() {
            this.nodeNameList.forEach(item => {
                if (item.id == this.searchForm.nodeId) {
                    this.searchForm.knowledgeSource = item.knowledgeSource
                }
            })
        },

        getMetadata(parentId) {
            this.$axios(this.api.metadata.selectAllByBasicDataId, {
                basicDataId: this.listSetlectData.metaId,
            }, 'get').then(data => {
                if (data && data.status) {
                    this.associationList = data.data
                }
            })
            console.log('============')
            console.log(parentId)
            this.$axios(this.api.academic.knowledgegraphnodeGetById + this.listSetlectData.id).then(res => {
                if (res.status) {
                    this.fatherNodeList = res.data
                    if (parentId) {
                        this.$nextTick(() => {
                            this.searchForm.parentId = parentId
                        })
                    }
                }
            })
        },

        setNodeNameList() {
            this.searchForm.nodeId = ''
            this.searchForm.knowledgeSource = ''
            this.nodeNameList = []
            if (this.checkList.length > 0) {
                if (this.checkList.length == 1) {
                    if (this.checkList[0] == 2) {
                        this.getOtherData('common')
                    } else {
                        this.getOtherData('mine')
                    }
                } else {
                    this.getOtherData('mine', 'common')
                }
            }
        },

        //name mine我的节点 common公共节点
        getOtherData(name, name2) {
            let data
            if (!name2) {
                data = {
                    [name]: 1,
                }
            } else {
                data = {
                    [name]: 1,
                    [name2]: 1,
                }
            }
            this.$axios(this.api.academic.knowledgenodeKnowledgeGraphNodeList, {
                ...data,
                knowledgeId: this.listSetlectData.id
            }, 'get').then(data => {
                if (data && data.status) {
                    this.nodeNameList = data.data
                }
            })
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.id) {
                        this.$axios(this.api.academic.knowledgegraphnodeUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.academic.knowledgegraphnodeSave, {
                            ...this.searchForm,
                            knowledgeId: this.listSetlectData.id,
                        }, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}

.inputWidth {
    width: 270px;
}
</style>
